import { HttpErrorResponse } from '@angular/common/http';

import { AppError } from './app-error.model';

const DEFAULT_USER_MESSAGE = 'Something went wrong. Please try again.';

const toRecord = (value: unknown): Record<string, unknown> | null => {
  return value !== null && typeof value === 'object' ? (value as Record<string, unknown>) : null;
};

export const normalizeHttpError = (error: unknown): AppError => {
  if (error instanceof HttpErrorResponse) {
    const payload = toRecord(error.error);
    return {
      code: String(payload?.['code'] ?? `HTTP_${error.status || 0}`),
      userMessage: String(payload?.['userMessage'] ?? DEFAULT_USER_MESSAGE),
      technicalMessage: String(payload?.['technicalMessage'] ?? error.message),
      correlationId:
        String(payload?.['correlationId'] ?? error.headers?.get('X-Correlation-Id') ?? '') ||
        undefined,
      severity: (payload?.['severity'] as AppError['severity']) ?? 'medium',
    };
  }

  if (error instanceof Error) {
    return {
      code: 'UNEXPECTED_ERROR',
      userMessage: DEFAULT_USER_MESSAGE,
      technicalMessage: error.message,
      severity: 'high',
    };
  }

  return {
    code: 'UNKNOWN_ERROR',
    userMessage: DEFAULT_USER_MESSAGE,
    technicalMessage: 'Unknown throwable received',
    severity: 'medium',
  };
};
